import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "flex flex-wrap items-center justify-between w-full md:flex-nowrap" }
const _hoisted_4 = {
  key: 0,
  class: "mt-2 border border-gray-400 rounded"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "px-4 py-2 bg-gray-100 border-b border-gray-400" }, "Resource Details", -1)
const _hoisted_6 = { class: "flex items-center space-x-4" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "text-blue-500 underline hover:cursor-pointer" }
const _hoisted_9 = { class: "capitalize" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("option", {
  class: "capitalize",
  value: "",
  selected: "",
  disabled: ""
}, "Please select", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("option", {
  class: "capitalize",
  value: "activity"
}, "Activity", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("option", {
  class: "capitalize",
  value: "supporting-asset"
}, "Brick Club resources", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("option", {
  class: "capitalize",
  value: "club-promotion"
}, "Advocacy and marketing materials", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("option", {
  class: "capitalize",
  value: "facilitation-aid"
}, "Facilitation resources", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("option", {
  class: "capitalize",
  value: "training-resources"
}, "Training resources", -1)
const _hoisted_16 = [
  _hoisted_10,
  _hoisted_11,
  _hoisted_12,
  _hoisted_13,
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("option", {
  class: "capitalize",
  value: "",
  selected: "",
  disabled: ""
}, "Please select", -1)
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "mt-2 space-y-2" }
const _hoisted_20 = ["value", "checked"]
const _hoisted_21 = {
  class: "inline-block pl-[0.15rem]",
  for: "checkboxDefault"
}
const _hoisted_22 = { class: "mt-2 space-y-2" }
const _hoisted_23 = { class: "block space-x-2" }
const _hoisted_24 = ["checked"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", {
  class: "inline-block pl-[0.15rem]",
  for: "checkboxDefault"
}, " Yes", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_27 = {
  key: 0,
  class: "px-4 py-4"
}
const _hoisted_28 = { class: "text-lg text-blue-500 underline" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "w-4 h-4 hover:text-red-500",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z" })
], -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = { class: "flex items-center justify-center w-full" }
const _hoisted_33 = {
  for: "dropzone-file",
  class: "flex flex-col items-center justify-center w-full h-64 m-4 border border-gray-500 rounded-lg cursor-pointer bg-play-gray hover:bg-gray-100"
}
const _hoisted_34 = /*#__PURE__*/_createStaticVNode("<div class=\"flex flex-col items-center justify-center pt-5 pb-6\"><svg xmlns=\"http://www.w3.org/2000/svg\" class=\"w-16 h-16 text-blue-500\" width=\"16\" height=\"16\" fill=\"currentColor\" viewBox=\"0 0 16 16\"><path d=\"M4.98 4a.5.5 0 0 0-.39.188L1.54 8H6a.5.5 0 0 1 .5.5 1.5 1.5 0 1 0 3 0A.5.5 0 0 1 10 8h4.46l-3.05-3.812A.5.5 0 0 0 11.02 4H4.98zm9.954 5H10.45a2.5 2.5 0 0 1-4.9 0H1.066l.32 2.562a.5.5 0 0 0 .497.438h12.234a.5.5 0 0 0 .496-.438L14.933 9zM3.809 3.563A1.5 1.5 0 0 1 4.981 3h6.038a1.5 1.5 0 0 1 1.172.563l3.7 4.625a.5.5 0 0 1 .105.374l-.39 3.124A1.5 1.5 0 0 1 14.117 13H1.883a1.5 1.5 0 0 1-1.489-1.314l-.39-3.124a.5.5 0 0 1 .106-.374l3.7-4.625z\"></path></svg><p class=\"text-lg text-black\">Click here to add a file to upload</p><p class=\"text-gray-600\">Maximum file size 10MB.</p></div>", 1)
const _hoisted_35 = {
  key: 1,
  class: "mt-2 border border-gray-400 rounded"
}

import { ref } from "vue";
import { storeToRefs } from "pinia";
import { useRoute } from "vue-router";

import TabGroup from "@/components/TabGroup.vue";
import TitleHeader from "@/components/TitleHeader.vue";
import TagSelector from "@/components/TagSelector.vue";
import ListRowItem from "@/components/ListRowItem.vue";
import SimpleEditor from "@/components/SimpleEditor.vue";
import DefaultButton from "@/components/DefaultButton.vue";

import api from "@/api/api";
import router from "@/router";
import { Resource, Tag, File } from "@/types";
import { useGlobalStore, useUserStore } from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditResource',
  async setup(__props) {

let __temp: any, __restore: any

const globalStore = useGlobalStore();
const route = useRoute();
const { user } = storeToRefs(useUserStore());
const { course_roles } = storeToRefs(globalStore);

const isSaving = ref(false);

const languages = ref([] as string[]);

const selectedTab = ref("summary");
const tabs = [
  {
    id: "summary",
    name: "Summary",
  },
  {
    id: "resource_description",
    name: "Resource Description",
  },
];

const resource = ref({} as Resource);
const tags = ref([] as Tag[]);
const files = ref([] as File[]);
const required_roles = ref([] as number[]);

async function saveResource() {

  try {
    isSaving.value = true;

    const response = await api.resources.updateResource({
      resource: resource.value,
      tags: tags.value,
      files: files.value,
      required_roles: required_roles.value,
    });

    if (response.meta.status === 200) {
      globalStore.toast("SUCCESS", "Resource updated");
      return router.push(`/dashboard/resources/${response.data.resource.id}`);
    } else {
      throw Error();
    }
  } catch (e) {
    console.log("ERROR", e);
    globalStore.toast("ERROR", "Error updating Resource");
  } finally {
    isSaving.value = false;
  }
}

function setTags(e: number[]) {
  tags.value = e;
}

function addRequiredRoles(e: any) {
  const roleId: number = e.target.value;
  const role = course_roles.value.find(i => i.id == roleId);

  if (!role) return;

  if (role.name === "paid-professional") {
    resource.value.paid = true;
  }

  // If role is already in array, remove it
  if (required_roles.value.find((i: number) => i === role?.id)) {
    const roleIndex = required_roles.value.findIndex(i => i === role?.id);
    return required_roles.value.splice(roleIndex, 1);
  }

  required_roles.value.push(role!.id);
}

function formatBytes(bytes: number) {
  if (bytes == 0) return "0 Bytes";
  var k = 1024,
    sizes = ["b", "kb", "mb"],
    i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
}

function isRoleSelected(id: number) {
  if (!required_roles.value.length) {
    return false;
  }

  if (required_roles.value.find(i => i === id)) {
    return true;
  }

  return false;
}

async function uploadFile(e: any, thumbnail: boolean = false) {
  if (!e.target || !e.target.files) {
    return;
  }

  const file = e.target.files[0];

  const form = new FormData();
  form.append("file", file);
  form.append("azure_directory_id", resource.value.azure_directory_id);

  const response = await api.resources.uploadResource(form);

  if (thumbnail) {
    resource.value.thumbnail = response.data.path;
    return;
  }

  if (response.data.id) {
    resource.value.files.push(response.data);
  }
}

async function deleteFile(id: number) {
  const response = await api.resources.deleteFile(id);

  if (response.data.deleted) {
    const index = files.value.findIndex(i => i.id === id);
    files.value.splice(index, 1);
    return globalStore.toast("SUCCESS", "File deleted");
  }

  return globalStore.toast("ERROR", "Error deleting file");
}

languages.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.misc.listLanguages())),
  __temp = await __temp,
  __restore(),
  __temp
)).languages;
resource.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.resources.getResource(String(route.params.id)))),
  __temp = await __temp,
  __restore(),
  __temp
)).data.resource;
tags.value = resource.value.tags.map(tag => {
  return tag.id;
});
files.value = resource.value.files;
required_roles.value = resource.value.roles.map(role => {
  return role.id;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers(saveResource, ["prevent"]),
    class: "mt-6 mb-16"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(TitleHeader, {
          title: resource.value.title
        }, null, 8, ["title"])
      ])
    ]),
    _createVNode(TabGroup, {
      tabs: tabs,
      selectedTab: selectedTab.value,
      onSelect: _cache[0] || (_cache[0] = (tab) => selectedTab.value = tab)
    }, null, 8, ["selectedTab"]),
    (selectedTab.value === 'summary')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(ListRowItem, { title: "Title" }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "payment",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((resource.value.title) = $event)),
                class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                required: ""
              }, null, 512), [
                [_vModelText, resource.value.title]
              ])
            ]),
            _: 1
          }),
          _createVNode(ListRowItem, { title: "Subtitle" }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "payment",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((resource.value.subtitle) = $event)),
                class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                required: ""
              }, null, 512), [
                [_vModelText, resource.value.subtitle]
              ])
            ]),
            _: 1
          }),
          _createVNode(ListRowItem, { title: "Cover Image" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("img", {
                  src: resource.value.thumbnail ? resource.value.thumbnail : 'https://placeholder.com/400x400.png',
                  alt: "Thumbnail",
                  class: "w-64 h-64"
                }, null, 8, _hoisted_7),
                _createElementVNode("label", _hoisted_8, [
                  _createTextVNode(" Change "),
                  _createElementVNode("input", {
                    ref: "thumbnailInput",
                    onChange: _cache[3] || (_cache[3] = e => uploadFile(e, true)),
                    type: "file",
                    class: "hidden"
                  }, null, 544)
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(ListRowItem, {
            title: "Author",
            class: "bg-play-gray"
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(user).first_name) + " " + _toDisplayString(_unref(user).last_name), 1)
            ]),
            _: 1
          }),
          _createVNode(ListRowItem, { title: "Type" }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("select", {
                id: "subscription",
                class: "capitalize text-black border w-full rounded focus:outline-none focus:shadow-outline-primary font-normal transition duration-50 ease-in px-3 py-1.5 pr-8 h-10 border-gray-600",
                required: "",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((resource.value.type) = $event))
              }, _hoisted_16, 512), [
                [_vModelSelect, resource.value.type]
              ])
            ]),
            _: 1
          }),
          _createVNode(ListRowItem, { title: "Language" }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("select", {
                id: "subscription",
                class: "capitalize text-black border w-full rounded focus:outline-none focus:shadow-outline-primary font-normal transition duration-50 ease-in px-3 py-1.5 pr-8 h-10 border-gray-600",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((resource.value.language) = $event)),
                required: ""
              }, [
                _hoisted_17,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(languages.value, (language) => {
                  return (_openBlock(), _createElementBlock("option", {
                    class: "capitalize",
                    value: language,
                    key: language
                  }, _toDisplayString(_ctx.$t(language)), 9, _hoisted_18))
                }), 128))
              ], 512), [
                [_vModelSelect, resource.value.language]
              ])
            ]),
            _: 1
          }),
          _createVNode(ListRowItem, { title: "This resource is for" }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createElementVNode("ul", _hoisted_19, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(course_roles), (role) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "block space-x-2",
                      key: role.id
                    }, [
                      _createElementVNode("input", {
                        type: "checkbox",
                        value: role.id,
                        class: "rounded hover:cursor-pointer",
                        checked: isRoleSelected(role.id),
                        onChange: addRequiredRoles
                      }, null, 40, _hoisted_20),
                      _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t(role.name)), 1)
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(ListRowItem, {
            title: "Paid Resource?",
            "center-label": false
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createElementVNode("ul", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((resource.value.paid) = $event)),
                      checked: resource.value.paid,
                      class: "rounded hover:cursor-pointer"
                    }, null, 8, _hoisted_24), [
                      [_vModelCheckbox, resource.value.paid]
                    ]),
                    _hoisted_25
                  ])
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(ListRowItem, { title: "Tags" }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(TagSelector, {
                  onChange: setTags,
                  tags: resource.value.tags,
                  type: "resource",
                  multiple: ""
                }, null, 8, ["tags"])
              ])
            ]),
            _: 1
          }),
          _createVNode(ListRowItem, {
            title: "Resources",
            class: "bg-play-gray"
          }, {
            default: _withCtx(() => [
              _hoisted_26
            ]),
            _: 1
          }),
          _createElementVNode("div", null, [
            _createElementVNode("div", null, [
              (files.value)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_27, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(files.value, (file, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: index,
                        class: "flex justify-between w-full"
                      }, [
                        _createElementVNode("span", _hoisted_28, _toDisplayString(file.name) + " (" + _toDisplayString(formatBytes(file.size)) + ")", 1),
                        _createElementVNode("button", {
                          onClick: ($event: any) => (deleteFile(file.id)),
                          type: "button"
                        }, _hoisted_31, 8, _hoisted_29)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("label", _hoisted_33, [
                  _hoisted_34,
                  _createElementVNode("input", {
                    id: "dropzone-file",
                    onChange: uploadFile,
                    type: "file",
                    class: "hidden"
                  }, null, 32)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (selectedTab.value === 'resource_description')
      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
          _createVNode(SimpleEditor, {
            onOnChange: _cache[7] || (_cache[7] = $event => (resource.value.description = $event)),
            content: resource.value.description
          }, null, 8, ["content"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(DefaultButton, {
      type: "primary",
      class: "mt-4",
      "is-form-submit": true,
      loading: isSaving.value,
      disabled: isSaving.value
    }, {
      default: _withCtx(() => [
        _createTextVNode("Submit Resource")
      ]),
      _: 1
    }, 8, ["loading", "disabled"])
  ], 40, _hoisted_1))
}
}

})